authorizedOrPending